/* istanbul ignore next */
const styles = ({ spacing: { unit } }) => ({
  gridActionModalWrapper: {
    '& .btn-primary': {
      borderRadius: unit * 3,
      padding: `${unit}px ${unit * 4}px !important`
    },
    '& p[class*="modalText"]': {
      overflowWrap: 'break-word'
    }
  }
});
export default styles;
